import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.png";
import { AppBar, Drawer, ListItem, Toolbar } from "@material-ui/core";
import { TbWorld } from "react-icons/tb";
import { FaPhoneAlt } from "react-icons/fa";
import { FaPlay } from "react-icons/fa6";
import { Box, Modal } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import { IoStar } from "react-icons/io5";
import { makeStyles } from "@material-ui/core/styles";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
// };

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  appBarItems: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobileMenuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawerIcon: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  drawer: {
    width: 300,
  },
}));

const TestimonialVideo = () => {
  const navigate = useNavigate();

  const handleAboutLogoClick = () => {
    localStorage.setItem("cameFromAbout", "true");
    navigate("/");
  };

  const [open, setOpen] = useState(false);
  const [openTwo, setOpenTwo] = useState(false);
  const [openThree, setOpenThree] = useState(false);
  const [openFour, setOpenFour] = useState(false);
  const [openFive, setOpenFive] = useState(false);

  const videoRefOne = useRef(null);
  const videoRefTwo = useRef(null);
  const videoRefThree = useRef(null);
  const videoRefFour = useRef(null);
  const videoRefFive = useRef(null);

  // Handle play/pause for Modal 1
  useEffect(() => {
    const video = videoRefOne.current;
    if (open && video) {
      video.play();
    } else if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }, [open]);

  // Handle play/pause for Modal 2
  useEffect(() => {
    const video = videoRefTwo.current;
    if (openTwo && video) {
      video.play();
    } else if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }, [openTwo]);

  // Handle play/pause for Modal 3
  useEffect(() => {
    const video = videoRefThree.current;
    if (openThree && video) {
      video.play();
    } else if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }, [openThree]);

  // Handle play/pause for Modal 4
  useEffect(() => {
    const video = videoRefFour.current;
    if (openFour && video) {
      video.play();
    } else if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }, [openFour]);

  // Handle play/pause for Modal 5
  useEffect(() => {
    const video = videoRefFive.current;
    if (openFive && video) {
      video.play();
    } else if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }, [openFive]);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  const classes = useStyles();

  return (
    <div className="testimonials_vd_bg">
      <div className="main-header">
        <header className="scrolled header-wrapper">
          <AppBar position="static" className="header_secondsec">
            <Toolbar className="container-fluid p-0 w-100 justify-content-between header_toolbar">
              <div className="hd_navigation">
                <div
                  className="d-flex hd_nav_lft"
                  onClick={handleAboutLogoClick}
                >
                  <Link className="logo-wrapper">
                    <img src={Logo} className="img-fluid" alt="logo" />
                  </Link>
                </div>

                <div className="hd_nav_links_cntr">
                  <Link to="/about" className="hd_nav_link">
                    About
                  </Link>
                  <Link to="/services" className="hd_nav_link">
                    Services
                  </Link>
                  <Link to="/projects" className="hd_nav_link">
                    Projects
                  </Link>
                  <Link to="/testimonials" className="hd_nav_link">
                    Testimonials
                  </Link>
                </div>

                <div className="rightside_menu">
                  <div className="header_btn_wrap">
                    <button
                      className="header-btn"
                      onClick={() => navigate("/contact-us")}
                    >
                      <span className="web_icon">
                        <FaPhoneAlt />
                      </span>
                      <span className="">Contact</span>
                    </button>
                    <button
                      className="header-btn"
                      onClick={() =>
                        window.open("https://beleaftechnologies.com/", "_blank")
                      }
                    >
                      <span className="web_icon">
                        <TbWorld />
                      </span>
                      <span className="">Website</span>
                    </button>
                  </div>
                </div>

                <div className="header_bars" onClick={handleMobileMenuOpen}>
                  <i className="fa-solid fa-bars"></i>
                </div>
              </div>
            </Toolbar>
          </AppBar>

          <Drawer
            anchor="left"
            open={mobileMenuOpen}
            onClose={handleMobileMenuClose}
            className={`mobile-drawer ${classes.drawer} gr-mob_drawer`}
          >
            <div className={` ${classes.mobileMenu}`}>
              <div className="logo_new_sectio mobile_menu_icon">
                <div
                  className="mobile_logo_wrap"
                  onClick={handleAboutLogoClick}
                >
                  <img src={Logo} alt="logo" />
                </div>
              </div>

              <div className="menu_statis">
                <ListItem button className="drawa">
                  <Link className="hd_nav_link" to="/about">
                    About
                  </Link>
                </ListItem>
                <ListItem button className="drawa">
                  <Link className="hd_nav_link" to="/services">
                    Services
                  </Link>
                </ListItem>
                <ListItem button className="drawa">
                  <Link className="hd_nav_link" to="/projects">
                    Projects
                  </Link>
                </ListItem>
                <ListItem button className="drawa">
                  <Link className="hd_nav_link" to="/testimonials">
                    Testimonials
                  </Link>
                </ListItem>

                <ListItem button className="drawa">
                  <button
                    className="header-btn"
                    onClick={() => navigate("/contact-us")}
                  >
                    <span className="web_icon">
                      <FaPhoneAlt />
                    </span>
                    <span>Contact</span>
                  </button>
                </ListItem>

                <ListItem button className="drawa">
                  <button
                    className="header-btn"
                    onClick={() =>
                      window.open("https://beleaftechnologies.com/", "_blank")
                    }
                  >
                    <span className="web_icon">
                      <TbWorld />
                    </span>
                    <span className="">Website</span>
                  </button>
                </ListItem>
              </div>
            </div>
          </Drawer>
        </header>
      </div>

      <main className="header-wrapper tst_video_main">
        <section>
          <h2 className="testimonial_title">
            Client Testimonials That Reflect Our Work
          </h2>
          <p className="testimonial_content">
            Hear what our clients say about their journey with Beleaf
            Technologies from initial idea to innovative, successful outcome.
          </p>

          <div className="row g-4 testimonial_row">
            <div className="col-xl-4 col-md-6">
              <div className="testimonial_card">
                <div
                  className="testimonial_video_wrap"
                  onClick={() => setOpenFour(true)}
                >
                  <img
                    src='https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreicn5maey77naa4uhve5whi4w6viletgki3k6pi7pny2yssd3ye6ni'
                    alt=""
                    className="w-100"
                  />

                  <span className="tst-play">
                    <FaPlay />
                  </span>
                </div>
                <div className="testimonial_btm">
                  <div className="testimonial_btm_lft">
                    <h4 className="tst_cl_name">MR. ABDULLAH</h4>
                    <p className="tst_cl_desc">CEO and founder of Crydible</p>
                  </div>
                  <div className="testimonial_btm_rgt">
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 mt-4 mt-md-0">
              <div className="testimonial_card">
                <div
                  className="testimonial_video_wrap"
                  onClick={() => setOpen(true)}
                >
                  <img
                    src='https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreie2jpirxhuiqm3isaf7mhu2pagnkyf2lsbbs2eil3vxjatxwz2eki'
                    alt=""
                    className="w-100"
                  />

                  <span className="tst-play">
                    <FaPlay />
                  </span>
                </div>
                <div className="testimonial_btm">
                  <div className="testimonial_btm_lft">
                    <h4 className="tst_cl_name">MR. SHANE</h4>
                    <p className="tst_cl_desc">
                      CEO and founder of Screaming Chicken
                    </p>
                  </div>
                  <div className="testimonial_btm_rgt">
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 mt-4 mt-xl-0">
              <div className="testimonial_card">
                <div
                  className="testimonial_video_wrap"
                  onClick={() => setOpenTwo(true)}
                >
                  <img
                    src='https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidsjgb44parva5nemsoozrstc3ijujdffhrveyxpgghe6z5x2w6bi'
                    alt=""
                    className="w-100"
                  />

                  <span className="tst-play">
                    <FaPlay />
                  </span>
                </div>
                <div className="testimonial_btm">
                  <div className="testimonial_btm_lft">
                    <h4 className="tst_cl_name">MR. VEIKO</h4>
                    <p className="tst_cl_desc">CEO and founder of Binarge</p>
                  </div>
                  <div className="testimonial_btm_rgt">
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 mt-4">
              <div className="testimonial_card">
                <div
                  className="testimonial_video_wrap"
                  onClick={() => setOpenThree(true)}
                >
                  <img
                    src='https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidxc3mexmx753oz5hltf4eeqwopxregpsn5pz4litx6vvciw72rxm'
                    alt=""
                    className="w-100"
                  />

                  <span className="tst-play">
                    <FaPlay />
                  </span>
                </div>
                <div className="testimonial_btm">
                  <div className="testimonial_btm_lft">
                    <h4 className="tst_cl_name">MR. DIMITRI</h4>
                    <p className="tst_cl_desc">CEO and founder of Fidex</p>
                  </div>
                  <div className="testimonial_btm_rgt">
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 mt-4">
              <div className="testimonial_card">
                <div
                  className="testimonial_video_wrap"
                  onClick={() => setOpenFive(true)}
                >
                  <img
                    src='https://res.cloudinary.com/dr3lpkvua/image/upload/v1783347247/Frame_16128_feas4a.png'
                    alt=""
                    className="w-100"
                  />

                  <span className="tst-play">
                    <FaPlay />
                  </span>
                </div>
                <div className="testimonial_btm">
                  <div className="testimonial_btm_lft">
                    <h4 className="tst_cl_name">MR. UMAIR</h4>
                    <p className="tst_cl_desc">CEO and founder of Superblock</p>
                  </div>
                  <div className="testimonial_btm_rgt">
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                    <span>
                      <IoStar />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <>
              <Modal
                keepMounted
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
              >
                <Box className="modal_video_wrap">
                  <div>
                    <video
                      ref={videoRefOne}
                      className="w-100"
                      // playsInline
                      // autoPlay
                      controls
                    >
                      <source
                        src="https://res.cloudinary.com/dmjw7pe6k/video/upload/v1745324172/SCKN_Testimonal_hreunc.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </Box>
              </Modal>
            </>

            <>
              <Modal
                keepMounted
                open={openTwo}
                onClose={() => setOpenTwo(false)}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
              >
                <Box
                  //  sx={style}

                  className="modal_video_wrap"
                >
                  <div>
                    <video
                      ref={videoRefTwo}
                      className="w-100"
                      // playsInline
                      // autoPlay
                      controls
                    >
                      <source
                        src="https://res.cloudinary.com/dmjw7pe6k/video/upload/v1745324494/Binarge_Testimonal_Final_dv48t1.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </Box>
              </Modal>
            </>

            <>
              <Modal
                keepMounted
                open={openThree}
                onClose={() => setOpenThree(false)}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
              >
                <Box className="modal_video_wrap">
                  <div>
                    <video
                      ref={videoRefThree}
                      className="w-100"
                      // playsInline
                      // autoPlay
                      controls
                    >
                      <source
                        src="https://res.cloudinary.com/dmjw7pe6k/video/upload/v1745386644/Home_jrjq25.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </Box>
              </Modal>
            </>

            <>
              <Modal
                keepMounted
                open={openFour}
                onClose={() => setOpenFour(false)}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
              >
                <Box className="modal_video_wrap">
                  <div>
                    <video
                      ref={videoRefFour}
                      className="w-100"
                      // playsInline
                      // autoPlay
                      controls
                    >
                      <source
                        src="https://res.cloudinary.com/dmjw7pe6k/video/upload/v1751626386/Crydible_kwtseo.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </Box>
              </Modal>
            </>

            <>
              <Modal
                keepMounted
                open={openFive}
                onClose={() => setOpenFive(false)}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
              >
                <Box className="modal_video_wrap">
                  <div>
                    <video
                      ref={videoRefFive}
                      className="w-100"
                      // playsInline
                      // autoPlay
                      controls
                    >
                      <source
                        src="https://res.cloudinary.com/dr3lpkvua/video/upload/v1783347197/Super_Block_Testimonial_j92d7x.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </Box>
              </Modal>
            </>
          </div>
        </section>
      </main>
    </div>
  );
};

export default TestimonialVideo;
